<template>
  <NuxtLayout>
    <CookieControl :locale="language.locale.value" />
      <NuxtPage />
  </NuxtLayout>
</template>
<script setup lang="ts">

const {cookiesEnabledIds} = useCookieControl()
const {initialize, enableAnalytics} = useGtag()
const language = useI18n();


watch(
    () => cookiesEnabledIds.value,
    (current, previous) => {
      if (
          !previous?.includes('google-analytics') &&
          current?.includes('google-analytics')
      ) {
        initialize()
        enableAnalytics()
      }
    },
    { deep: true },
)
</script>
<style>
.upperCase {
  text-transform: capitalize;
}
</style>

